<template>
    <div class="booking-passengers">
        <h4>Passengers</h4>
        <div class="form-group">
            <label :for="`adults-${tripId}`">Adults</label>
            <input v-model.number="passengers.adults" type="number" min="0" class="form-control" :id="`adults-${tripId}`" />
            <div v-if="errors?.adults?.length > 0" class="booking-error">
                <p>There are some problems with this field.</p>
                <ul>
                    <li v-for="error, index in errors.adults" :key="index">{{ error }}</li>
                </ul>
            </div>
        </div>        
        <div class="form-group">
            <label :for="`children_under16-${tripId}`">Children (under 16)</label>
            <input v-model.number="passengers.children_under16" type="number" min="0" class="form-control" :id="`children_under16-${tripId}`" />
            <div v-if="errors?.children_under16?.length > 0" class="booking-error">
                <p>There are some problems with this field.</p>
                <ul>
                    <li v-for="error, index in errors.children_under16" :key="index">{{ error }}</li>
                </ul>
            </div>
        </div>
        <div class="form-group">
            <label :for="`children_under1-${tripId}`">Children (under 1)</label>
            <input v-model.number="passengers.children_under1" type="number" min="0" class="form-control" :id="`children_under1-${tripId}`" />
            <div v-if="errors?.children_under1?.length > 0" class="booking-error">
                <p>There are some problems with this field.</p>
                <ul>
                    <li v-for="error, index in errors.children_under1" :key="index">{{ error }}</li>
                </ul>
            </div>
        </div>
        <div class="form-group">
            <label :for="`dogs-${tripId}`">Dogs</label>
            <input v-model.number="passengers.dogs" type="number" min="0" class="form-control" :id="`dogs-${tripId}`" />
            <div v-if="errors?.dogs?.length > 0" class="booking-error">
                <p>There are some problems with this field.</p>
                <ul>
                    <li v-for="error, index in errors.dogs" :key="index">{{ error }}</li>
                </ul>
            </div>
        </div>
        <div class="form-group">
            <label :for="`bikes-${tripId}`">Bikes</label>
            <input v-model.number="passengers.bikes" type="number" min="0" class="form-control" :id="`bikes-${tripId}`" />
            <div v-if="errors?.bikes?.length > 0" class="booking-error">
                <p>There are some problems with this field.</p>
                <ul>
                    <li v-for="error, index in errors.bikes" :key="index">{{ error }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>  

<script>
export default {
    props: {
        modelValue: Object,
        tripId: Number,
        errors: Object
    },
    computed: {
        passengers: {
            get() { 
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    }
}
</script>

<style lang="scss">
.booking-passengers {
    h4 {
        font-size: 1.1rem;
    }

    margin-bottom: 40px;
}
</style>